"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AppsyncSubscriptionClient", {
    enumerable: true,
    get: function() {
        return AppsyncSubscriptionClient;
    }
});
var _backo2 = /*#__PURE__*/ _interopRequireDefault(require("backo2"));
var _eventemitter3 = require("eventemitter3");
var _utils = require("./utils");
var _printer = require("graphql/language/printer");
var _getOperationAST = require("graphql/utilities/getOperationAST");
var _symbolObservable = /*#__PURE__*/ _interopRequireDefault(require("symbol-observable"));
var _ulidx = require("ulidx");
var _protocol = require("./protocol");
var _defaults = require("./defaults");
var _messageTypes = /*#__PURE__*/ _interopRequireDefault(require("./message-types"));
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = (void 0) && (void 0).__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var _global = typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : {};
var NativeWebSocket = _global.WebSocket || _global.MozWebSocket;
var AppsyncSubscriptionClient = /*#__PURE__*/ function() {
    "use strict";
    function AppsyncSubscriptionClient(options) {
        _classCallCheck(this, AppsyncSubscriptionClient);
        var _ref = options || {}, url = _ref.url, connectionParams = _ref.connectionParams, _ref_connectionCallback = _ref.connectionCallback, connectionCallback = _ref_connectionCallback === void 0 ? undefined : _ref_connectionCallback, _ref_reconnectionAttempts = _ref.reconnectionAttempts, reconnectionAttempts = _ref_reconnectionAttempts === void 0 ? 5 : _ref_reconnectionAttempts;
        this.wsImpl = NativeWebSocket;
        this.connectionCallback = connectionCallback;
        this.url = url;
        this.operations = {};
        this.nextOperationId = 0;
        this.unsentMessagesQueue = [];
        this.reconnecting = false;
        this.reconnectionAttempts = reconnectionAttempts;
        this.closedByUser = false;
        this.waitingToConnect = false;
        this.backoff = new _backo2.default({
            jitter: 0.5
        });
        this.eventEmitter = new _eventemitter3.EventEmitter();
        this.client = null;
        this.maxConnectTimeGenerator = AppsyncSubscriptionClient.createMaxConnectTimeGenerator();
        this.connectionParams = connectionParams;
    }
    var _proto = AppsyncSubscriptionClient.prototype;
    _proto.close = function close() {
        var isForced = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, closedByUser = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (this.client !== null) {
            this.closedByUser = closedByUser;
            if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, _messageTypes.default.GQL_CONNECTION_TERMINATE, null);
            }
            this.client.close();
            this.client.onopen = null;
            this.client.onclose = null;
            this.client.onerror = null;
            this.client.onmessage = null;
            this.client = null;
            this.eventEmitter.emit("disconnected");
            if (!isForced) {
                this.tryReconnect();
            }
        }
    };
    _proto.request = function request(request) {
        var getObserver = this.getObserver.bind(this);
        var executeOperation = this.executeOperation.bind(this);
        var unsubscribe = this.unsubscribe.bind(this);
        var opId;
        var _obj;
        return(_obj = {}, _defineProperty(_obj, _symbolObservable.default, function() {
            return this;
        }), _defineProperty(_obj, "subscribe", function subscribe(observerOrNext, onError, onComplete) {
            var observer = getObserver(observerOrNext, onError, onComplete);
            opId = executeOperation(request, function(error, result) {
                if (error === null && result === null) {
                    if (observer.complete) {
                        observer.complete();
                    }
                } else if (error) {
                    if (observer.error) {
                        observer.error(error[0]);
                    }
                } else {
                    if (observer.next) {
                        observer.next(result);
                    }
                }
            });
            return {
                unsubscribe: function() {
                    if (opId) {
                        unsubscribe(opId);
                        opId = null;
                    }
                }
            };
        }), _obj);
    };
    _proto.on = function on(eventName, callback, context) {
        var handler = this.eventEmitter.on(eventName, callback, context);
        return function() {
            handler.off(eventName, callback, context);
        };
    };
    _proto.onConnected = function onConnected(callback, context) {
        return this.on("connected", callback, context);
    };
    _proto.onConnecting = function onConnecting(callback, context) {
        return this.on("connecting", callback, context);
    };
    _proto.onDisconnected = function onDisconnected(callback, context) {
        return this.on("disconnected", callback, context);
    };
    _proto.onReconnected = function onReconnected(callback, context) {
        return this.on("reconnected", callback, context);
    };
    _proto.onReconnecting = function onReconnecting(callback, context) {
        return this.on("reconnecting", callback, context);
    };
    _proto.onError = function onError(callback, context) {
        return this.on("error", callback, context);
    };
    _proto.unsubscribeAll = function unsubscribeAll() {
        var _this = this;
        Object.keys(this.operations).forEach(function(subId) {
            _this.unsubscribe(subId);
        });
    };
    _proto.executeOperation = function executeOperation(options, handler) {
        var _this = this;
        if (this.client === null) {
            this.waitingToConnect = true;
            var delay = this.backoff.duration();
            var _this1 = this;
            setTimeout(/*#__PURE__*/ _asyncToGenerator(function() {
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // console.log(`Connecting from executeOperation() with delay ${delay}.`)
                            return [
                                4,
                                _this1.connect()
                            ];
                        case 1:
                            _state.sent();
                            _this1.waitingToConnect = false;
                            return [
                                2
                            ];
                    }
                });
            }), delay);
        }
        var _this2 = this;
        var prepareOptionsForAppsync = function() {
            var _ref = _asyncToGenerator(function(options) {
                var _tmp, _tmp1;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // AppSync expects GraphQL operation to be defined as a JSON-encoded object in a "data" property
                            options.data = JSON.stringify({
                                query: typeof options.query === "string" ? options.query : (0, _printer.print)(options.query),
                                variables: options.variables
                            });
                            _tmp = {};
                            if (!(typeof _this2.connectionParams === "function")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this2.connectionParams()
                            ];
                        case 1:
                            _tmp1 = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            _tmp1 = _this2.connectionParams;
                            _state.label = 3;
                        case 3:
                            // AppSync only permits authorized operations
                            options.extensions = (_tmp.authorization = _tmp1, _tmp);
                            // AppSync does not care about these properties
                            delete options.operationName;
                            delete options.variables;
                            return [
                                2,
                                options
                            ];
                    }
                });
            });
            return function prepareOptionsForAppsync(options) {
                return _ref.apply(this, arguments);
            };
        }();
        var opId = AppsyncSubscriptionClient.generateOperationId();
        this.operations[opId] = {
            options: options,
            handler: handler
        };
        prepareOptionsForAppsync(options).then(function(processedOptions) {
            _this.checkOperationOptions(processedOptions, handler);
            if (_this.operations[opId]) {
                _this.operations[opId] = {
                    options: processedOptions,
                    handler: handler
                };
                _this.sendMessage(opId, _messageTypes.default.GQL_START, processedOptions);
            }
        }).catch(function(error) {
            _this.unsubscribe(opId);
            handler(_this.formatErrors(error));
        });
        return opId;
    };
    _proto.getObserver = function getObserver(observerOrNext, error, complete) {
        if (typeof observerOrNext === "function") {
            return {
                next: function(v) {
                    return observerOrNext(v);
                },
                error: function(e) {
                    return error && error(e);
                },
                complete: function() {
                    return complete && complete();
                }
            };
        }
        return observerOrNext;
    };
    _proto.clearCheckConnectionInterval = function clearCheckConnectionInterval() {
        if (this.checkConnectionIntervalId) {
            clearInterval(this.checkConnectionIntervalId);
            this.checkConnectionIntervalId = null;
        }
    };
    _proto.clearMaxConnectTimeout = function clearMaxConnectTimeout() {
        if (this.maxConnectTimeoutId) {
            clearTimeout(this.maxConnectTimeoutId);
            this.maxConnectTimeoutId = null;
        }
    };
    _proto.clearTryReconnectTimeout = function clearTryReconnectTimeout() {
        if (this.tryReconnectTimeoutId) {
            clearTimeout(this.tryReconnectTimeoutId);
            this.tryReconnectTimeoutId = null;
        }
    };
    _proto.checkOperationOptions = function checkOperationOptions(options, handler) {
        var query = options.query, variables = options.variables, operationName = options.operationName;
        if (!query) {
            throw new Error("Must provide a query.");
        }
        if (!handler) {
            throw new Error("Must provide an handler.");
        }
        if (!(0, _utils.isString)(query) && !(0, _getOperationAST.getOperationAST)(query, operationName) || operationName && !(0, _utils.isString)(operationName) || variables && !(0, _utils.isObject)(variables)) {
            throw new Error("Incorrect option types. query must be a string or a document," + "`operationName` must be a string, and `variables` must be an object.");
        }
    };
    _proto.buildMessage = function buildMessage(id, type, payload) {
        var payloadToReturn = payload && payload.query ? _objectSpreadProps(_objectSpread({}, payload), {
            query: typeof payload.query === "string" ? payload.query : (0, _printer.print)(payload.query)
        }) : payload;
        return {
            id: id,
            type: type,
            payload: payloadToReturn
        };
    };
    // ensure we have an array of errors
    _proto.formatErrors = function formatErrors(errors) {
        if (Array.isArray(errors)) {
            return errors;
        }
        // TODO  we should not pass ValidationError to callback in the future.
        // ValidationError
        if (errors && errors.errors) {
            return this.formatErrors(errors.errors);
        }
        if (errors && errors.message) {
            return [
                errors
            ];
        }
        return [
            {
                name: "FormatedError",
                message: "Unknown error",
                originalError: errors
            }
        ];
    };
    _proto.sendMessage = function sendMessage(id, type, payload) {
        this.sendMessageRaw(this.buildMessage(id, type, payload));
    };
    // send message, or queue it if connection is not open
    _proto.sendMessageRaw = function sendMessageRaw(message) {
        switch(this.status){
            case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                try {
                    JSON.parse(serializedMessage);
                } catch (e) {
                    this.eventEmitter.emit("error", new Error("Message must be JSON-serializable. Got: ".concat(message)));
                }
                this.client.send(serializedMessage);
                break;
            case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;
            default:
                if (!this.reconnecting) {
                    this.eventEmitter.emit("error", new Error("A message was not sent because socket is not connected, is closing or " + "is already closed. Message was: " + JSON.stringify(message)));
                }
        }
    };
    _proto.tryReconnect = function tryReconnect() {
        var _this = this;
        if (this.backoff.attempts >= this.reconnectionAttempts) {
            return;
        }
        if (!this.reconnecting) {
            Object.keys(this.operations).forEach(function(key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, _messageTypes.default.GQL_START, _this.operations[key].options));
            });
            this.reconnecting = true;
        }
        this.clearTryReconnectTimeout();
        var delay = this.backoff.duration();
        var _this1 = this;
        this.tryReconnectTimeoutId = setTimeout(/*#__PURE__*/ _asyncToGenerator(function() {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.connect()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }), delay);
    };
    _proto.flushUnsentMessagesQueue = function flushUnsentMessagesQueue() {
        var _this = this;
        this.unsentMessagesQueue.forEach(function(message) {
            _this.sendMessageRaw(message);
        });
        this.unsentMessagesQueue = [];
    };
    _proto.checkConnection = function checkConnection() {
        if (this.wasKeepAliveReceived) {
            // console.log('checkConnection .. wasKeepAliveReceived')
            this.wasKeepAliveReceived = false;
            return;
        }
        if (!this.reconnecting) {
            // console.log('close() from checkConnection')
            this.close(false, true);
        }
    };
    _proto.checkMaxConnectTimeout = function checkMaxConnectTimeout() {
        var _this = this;
        this.clearMaxConnectTimeout();
        // Max timeout trying to connect
        this.maxConnectTimeoutId = setTimeout(function() {
            if (_this.status !== _this.wsImpl.OPEN) {
                _this.reconnecting = true;
                // console.log('close() from checkMaxConnectTimeout')
                _this.close(false, true);
            }
        }, this.maxConnectTimeGenerator.duration());
    };
    _proto.connect = function connect() {
        var _this = this;
        return _asyncToGenerator(function() {
            var _, _1, _tmp;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _1 = (_ = _this.wsImpl).bind;
                        if (!(typeof _this.url === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this.url()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = _this.url;
                        _state.label = 3;
                    case 3:
                        _this.client = new (_1.apply(_, [
                            void 0,
                            _tmp,
                            _protocol.GRAPHQL_WS
                        ]));
                        _this.checkMaxConnectTimeout();
                        _this.client.onopen = /*#__PURE__*/ _asyncToGenerator(function() {
                            return __generator(this, function(_state) {
                                if (_this.status === _this.wsImpl.OPEN) {
                                    _this.clearMaxConnectTimeout();
                                    _this.closedByUser = false;
                                    _this.eventEmitter.emit(_this.reconnecting ? "reconnecting" : "connecting");
                                    try {
                                        // Send CONNECTION_INIT message, no need to wait for connection to success (reduce roundtrips)
                                        _this.sendMessage(undefined, _messageTypes.default.GQL_CONNECTION_INIT, {});
                                        _this.flushUnsentMessagesQueue();
                                    } catch (error) {
                                        _this.sendMessage(undefined, _messageTypes.default.GQL_CONNECTION_ERROR, error);
                                        _this.flushUnsentMessagesQueue();
                                    }
                                }
                                return [
                                    2
                                ];
                            });
                        });
                        _this.client.onclose = function() {
                            if (!_this.closedByUser) {
                                // console.log('close() called by onclose callback')
                                _this.close(false, false);
                            }
                        };
                        _this.client.onerror = function(err) {
                            // Capture and ignore errors to prevent unhandled exceptions, wait for
                            // onclose to fire before attempting a re-connect.
                            _this.eventEmitter.emit("error", err);
                        };
                        _this.client.onmessage = function(param) {
                            var data = param.data;
                            _this.processReceivedData(data);
                        };
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.processReceivedData = function processReceivedData(receivedData) {
        var parsedMessage;
        var opId;
        try {
            parsedMessage = JSON.parse(receivedData);
            opId = parsedMessage.id;
        } catch (e) {
            throw new Error("Message must be JSON-parseable. Got: ".concat(receivedData));
        }
        if ([
            _messageTypes.default.GQL_DATA,
            _messageTypes.default.GQL_COMPLETE,
            _messageTypes.default.GQL_ERROR
        ].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
            this.unsubscribe(opId);
            return;
        }
        switch(parsedMessage.type){
            case _messageTypes.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) {
                    this.connectionCallback(parsedMessage.payload);
                }
                break;
            case _messageTypes.default.GQL_CONNECTION_START_ACK:
            case _messageTypes.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? "reconnected" : "connected", parsedMessage.payload);
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();
                if (this.connectionCallback) {
                    this.connectionCallback();
                }
                break;
            case _messageTypes.default.GQL_COMPLETE:
                var handler = this.operations[opId].handler;
                delete this.operations[opId];
                handler.call(this, null, null);
                break;
            case _messageTypes.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;
            case _messageTypes.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : _objectSpreadProps(_objectSpread({}, parsedMessage.payload), {
                    errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;
            case _messageTypes.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === "undefined";
                this.wasKeepAliveReceived = true;
                if (firstKA) {
                    this.checkConnection();
                }
                if (this.checkConnectionIntervalId) {
                    clearInterval(this.checkConnectionIntervalId);
                    this.checkConnection();
                }
                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), _defaults.WS_TIMEOUT);
                break;
            default:
                throw new Error("Invalid message type!");
        }
    };
    _proto.unsubscribe = function unsubscribe(opId) {
        if (this.operations[opId]) {
            delete this.operations[opId];
            this.sendMessage(opId, _messageTypes.default.GQL_STOP, undefined);
        }
    };
    AppsyncSubscriptionClient.createMaxConnectTimeGenerator = function createMaxConnectTimeGenerator() {
        return new _backo2.default({
            min: _defaults.MIN_WS_TIMEOUT,
            max: _defaults.WS_TIMEOUT,
            factor: 1.2
        });
    };
    // AppSync recommends using UUIDs for Subscription IDs but SubscriptionClient uses an incrementing number
    AppsyncSubscriptionClient.generateOperationId = function generateOperationId() {
        return (0, _ulidx.ulid)();
    };
    _createClass(AppsyncSubscriptionClient, [
        {
            key: "status",
            get: function get() {
                if (this.waitingToConnect) {
                    return this.wsImpl.CONNECTING;
                }
                if (this.client === null) {
                    return this.wsImpl.CLOSED;
                }
                return this.client.readyState;
            }
        }
    ]);
    return AppsyncSubscriptionClient;
}();

//# sourceMappingURL=appsync-subscription-client.js.map